$(document).on("change", "[data-behavior~=toggle-input-fields]", function(event) {
  let className = $(this).data('input-field-toggle-class');
  let disableStatus = !this.checked;

  $('.' + className).prop('disabled', disableStatus);
});